import { useEventCallback } from '@gitbook/util-react-hooks';

import { useAgentChatInputValue } from '../AgentChat';
import { triggerEditorMentionPicker } from '../ContentEditor';

interface UseAgentInputPromptArgs {
    inputKey: string;
    editable?: boolean;
    defer?: boolean;
}
/**
 * Hook to open the prompt templates palette by inserting a mention trigger into the input.
 */
export function useAgentInputPrompt(args: UseAgentInputPromptArgs) {
    const { editable = true, defer = false, inputKey } = args;
    const { setValue } = useAgentChatInputValue(inputKey);

    return useEventCallback((text: string, mentionTriggers: string = '/#@') => {
        if (!editable) {
            return;
        }

        if (defer) {
            setValue({
                content: (previousContent) => {
                    if (previousContent.isBlurred) {
                        return previousContent;
                    }
                    const change = previousContent.change();
                    change.blur();
                    return change.value;
                },
            });
        }

        const setInputWithPrompt = () => {
            setValue({
                content: (previousContent) => {
                    const change = previousContent.change();
                    change.selectAll().delete().insertText(text);
                    const endsWithMentionTrigger = text.match(new RegExp(`[${mentionTriggers}]$`));
                    if (endsWithMentionTrigger) {
                        triggerEditorMentionPicker(change, endsWithMentionTrigger[0]);
                    }
                    change.focus();
                    return change.value;
                },
            });
        };

        if (defer) {
            setTimeout(() => setInputWithPrompt(), 0);
            return;
        }

        setInputWithPrompt();
    });
}
